import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { Oval } from "react-loader-spinner"; // Import loader
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { StandardURL } from "../App";

const RegisterCaretaker = () => {
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    termsAndCondition: false,
    propertyid: "",
  });

  useEffect(() => {
    // Fetch propertyId from localStorage and update formData
    const propertyId = localStorage.getItem("selectedPropertyId");
    if (propertyId) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        propertyid: propertyId,
      }));
    }
  }, []); // Run this effect only once on component mount

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // Add loading state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    setIsLoading(true); // Set loading state to true
    e.preventDefault();
    try {
      // Include propertyid in the formData
      const updatedFormData = {
        ...formData,
        propertyid: localStorage.getItem("selectedPropertyId"),
      };

      const response = await axios.post(
        `${StandardURL}/iNyumba/auth/registercaretaker`,
        updatedFormData,
        {
          params: {
            accountType: "CARETAKER",
          },
        }
      );

      toast.success("Caretaker Registration is successful!");
      setIsLoading(false); // Set loading state to false
      navigate(-1);
    } catch (error) {
      console.error(error); // Display error message
      if (error.response && error.response.status === 401) {
        toast.error("Unauthorized access");
        setIsLoading(false); // Set loading state to false
      } else if (error.response && error.response.status === 406) {
        toast.error(
          "Wrong password format. Have a Number, Capital and Small letter and Special Character i.e @{}etc example P@ssw0rd10{}"
        );
        setIsLoading(false); // Set loading state to false
      } else {
        toast.error("An error occurred, please try again later");
        setIsLoading(false); // Set loading state to false
      }
    }
  };

return (
  <RoleGuard>
    <AuthGuard>
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 transform hover:scale-105 transition-all duration-300 ease-in-out">
          <div className="text-center">
            <h2 className="mt-2 text-4xl font-extrabold text-gray-900 leading-tight">
              Register Caretaker ✨
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              Fill in the details below to register a new caretaker.
            </p>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Email Address
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-base transition duration-200 ease-in-out"
                  placeholder="name@example.com"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <input
                type="hidden"
                name="propertyid"
                value={formData.propertyid}
              />

              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  Full Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  autoComplete="name"
                  required
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-base transition duration-200 ease-in-out"
                  placeholder="John Doe"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700">
                  Phone Number
                </label>
                <input
                  id="phoneNumber"
                  name="phoneNumber"
                  type="tel"
                  autoComplete="tel"
                  required
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-base transition duration-200 ease-in-out"
                  placeholder="+254 7XX XXX XXX"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="new-password"
                  required
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-base transition duration-200 ease-in-out"
                  placeholder="••••••••"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                  Confirm Password
                </label>
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  autoComplete="new-password"
                  required
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-base transition duration-200 ease-in-out"
                  placeholder="••••••••"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="flex items-center justify-between mt-6">
              <div className="flex items-center">
                <input
                  id="termsAndCondition"
                  name="termsAndCondition"
                  type="checkbox"
                  checked={formData.termsAndCondition}
                  onChange={() =>
                    setFormData({
                      ...formData,
                      termsAndCondition: !formData.termsAndCondition,
                    })
                  }
                  className="h-5 w-5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded-md cursor-pointer"
                />
                <label htmlFor="termsAndCondition" className="ml-2 block text-sm text-gray-900 cursor-pointer">
                  I agree to the <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">terms and conditions</a>
                </label>
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={isLoading}
                className={`
                  relative w-full flex justify-center py-2.5 px-4 border border-transparent text-lg font-semibold rounded-lg shadow-md
                  ${isLoading
                    ? "bg-indigo-400 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transform transition-all duration-200 ease-in-out hover:scale-105"
                  }
                  text-white
                `}
              >
                {isLoading ? (
                  <Oval
                    height={24}
                    width={24}
                    color="white"
                    visible={true}
                    ariaLabel="loading-indicator"
                    secondaryColor="white"
                    strokeWidth={5}
                    strokeWidthSecondary={5}
                  />
                ) : (
                  "Register Caretaker"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </AuthGuard>
  </RoleGuard>
);
};

export default RegisterCaretaker;
